// This func recieves another function as a callback and runs it when the DOMContentLoaded event is triggered

const onLoad = ( func ) => window.addEventListener( 'DOMContentLoaded', func );

export { onLoad };